import React, { Component } from 'react';
import { connect } from 'react-redux';
import ImageElement from '../question/imageElement';
import Video from '../question/video';
import { compose } from 'redux';
import WordCollection from '../../utils/question/wordCollection';
import Zoom from '../../../utils/animations/zoom';

const FeedbackLayout = (WrappedComponent) => {
	return class extends Component {
		constructor(props) {
			super(props);
			this.state = {
				showQuestion: false,
			};
		}

		render() {
			const {
				rightFeedbackProps: { feedbackQuestion },
				leftFeedbackProps: { videoId, imagesrc, jwPlayerId, queDesc, wordbank, questionId },
			} = this.props;
			const { showQuestion } = this.state;

			return (
				<span>
					<section className="container quiz-review-mode">
						<section className="quiz-area-question ">
							<Zoom
								className="btn btn-icon pull-right pad-no mar-no help-popup-link"
								data-toggle="tooltip"
								data-placement="top"
								title="Help"
							>
								<i
									className="fa fa-question-circle fa-2x"
									data-toggle="modal"
									data-target="#help-popup"
									aria-hidden="true"
								></i>
							</Zoom>
							<h4>
								{feedbackQuestion}
								{(!!queDesc || !!imagesrc || !!videoId || !!wordbank) && (
									<button
										className="viewQuestion btn btn-xs btn-info"
										onClick={() =>
											this.setState((prevState) => ({
												showQuestion: !prevState.showQuestion,
											}))
										}
									>
										{showQuestion ? 'Hide question' : 'See question again'}
									</button>
								)}
							</h4>

							{showQuestion && (
								<span className="" id="correct-answer-feedback">
									{(!!queDesc || !!imagesrc || !!videoId) && (
										<div className="paratext">
											{!!videoId ? (
												<Video videoId={videoId} queDesc={queDesc} jwPlayerId={jwPlayerId} />
											) : (
												(!!queDesc || !!imagesrc) && (
													<ImageElement imagesrc={imagesrc} queDesc={queDesc} />
												)
											)}
										</div>
									)}
									<WordCollection wordbank={wordbank} questionId={questionId} />
								</span>
							)}
						</section>
						<WrappedComponent {...this.props} />
					</section>
				</span>
			);
		}
	};
};

const mapStateToProps = (state) => {
	const {
		rightFeedbackProps,
		answerCount,
		leftFeedbackProps,
	} = state.rootReducer.testPageDetails;

	return {
		rightFeedbackProps,
		answerCount,
		leftFeedbackProps,
	};
};

const ComposedFeedBackLayout = compose(
	connect(mapStateToProps, null),
	FeedbackLayout,
);
export default ComposedFeedBackLayout;
